import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getLicenseKeyTypes() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_license_key_types'
      })
    }
  );
}

export function getOnlinelicenseProducts() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_online_license_products'
      })
    }
  );
}

export function getOfflinelicenseProducts() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_offline_license_products'
      })
    }
  );
}

export function getProducts() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_products'
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/keyLicenses.js